import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Eye, Loader2 } from "lucide-react";
import { adminApi } from "@/lib/adminApi";
import LandingPage from "./LandingPage";

export default function PagePreview() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");
  const params = new URLSearchParams(window.location.search);
  const embedded = params.get("embedded") === "1";
  const [pageId, setPageId] = useState(params.get("page") || "home");
  const receivedDraft = useRef(false);
  useEffect(() => {
    adminApi("/admin/site-content").then((data) => { if (!receivedDraft.current) setContent(data.draft); }).catch((e) => setError(e.message));
    window.scrollTo(0, 0);
    const tag = document.createElement("meta"); tag.name = "robots"; tag.content = "noindex,nofollow"; document.head.appendChild(tag);
    return () => tag.remove();
  }, []);
  useEffect(() => {
    if (!embedded) return;
    const receive = (event) => {
      if (event.origin !== window.location.origin || event.source !== window.parent || event.data?.type !== "meza-editor-preview" || !event.data.content?.layout) return;
      receivedDraft.current = true; setContent(event.data.content); setPageId(event.data.pageId);
    };
    window.addEventListener("message", receive);
    window.parent.postMessage({ type: "meza-preview-ready" }, window.location.origin);
    return () => window.removeEventListener("message", receive);
  }, [embedded]);
  return <div data-testid="draft-preview">
    {!embedded && <div className="sticky top-0 z-[70] bg-[#111c2e] border-b border-amber-500/50 px-4 sm:px-8 py-3 flex flex-wrap items-center justify-between gap-3">
      <span data-testid="draft-preview-notice" className="flex gap-2 items-center text-amber-300 text-sm"><Eye className="w-4 h-4" />Private draft · Not your live page</span>
      <Link to="/admin" data-testid="preview-back-editor" className="inline-flex items-center gap-2 text-white text-sm"><ArrowLeft className="w-4 h-4" />Back to editor</Link>
    </div>}
    {error ? <p role="alert" data-testid="preview-error" className="text-red-400 p-10">{error}</p> : content ? <LandingPage content={content} preview pageId={pageId} onSelect={embedded ? (id) => window.parent.postMessage({ type: "meza-select-section", id }, window.location.origin) : undefined} /> : <Loader2 className="animate-spin m-10 text-electric" data-testid="preview-loading" />}
  </div>;
}